export default __webpack_public_path__ + "90cae01b43043cbed46e8ef3d5ecbdc5.png";